module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/bridge_image_01-13182aaf321d76e483bf8664a9958c21.png";